import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import FluidImg from 'Components/Utility/FluidImg';
import imgixConfig from 'Config/imgix';
import { encodeSlug } from 'Helpers/Slug';
import store from 'Redux/store';

export default function PublisherBox({
  publisher,
  discounts,
  index,
  publisherCarousel,
  clickFunction,
  showDealNumbers,
}) {
  let imgSrc;
  let cssClass;
  let title;
  let fantasyVerse = false;

  let showDiscountBar = false;
  if (discounts > 0) showDiscountBar = true;
  if (!showDealNumbers) showDiscountBar = false;

  const trimmedPublisher = publisher.trim();
  if (trimmedPublisher === 'aspyr') {
    imgSrc = 'aspyr-2019.png';
    cssClass = 'aspyr-logo';
    title = 'Aspyr';
  }

  if (trimmedPublisher === 'warner bros. interactive entertainment') {
    imgSrc = 'warner-bros.png';
    cssClass = 'warner-logo';
    title = 'Warner Bros. Interactive Entertainment';
  }

  if (trimmedPublisher === 'bethesda softworks') {
    imgSrc = 'bethesda-black.png';
    cssClass = 'bethesda-logo';
    title = 'Bethesda';
  }

  if (trimmedPublisher === '2k games') {
    imgSrc = '2kgames.png';
    cssClass = 'two-logo';
    title = '2K Games';
  }

  if (trimmedPublisher === 'sega') {
    imgSrc = 'sega-blue.png';
    cssClass = 'sega-logo';
    title = 'Sega';
  }

  if (trimmedPublisher === 'capcom') {
    imgSrc = 'capcom-logo.png';
    cssClass = 'capcom-logo';
    title = 'Capcom';
  }

  if (trimmedPublisher === 'bandai namco entertainment') {
    imgSrc = 'bandai-namco-stacked.png';
    cssClass = 'bandai-logo';
    title = 'Bandai Namco Entertainment';
  }

  if (trimmedPublisher === 'thq nordic') {
    imgSrc = 'thq-nordic-logo.png';
    cssClass = 'thq-nordic-logo';
    title = 'THQ Nordic';
  }

  if (trimmedPublisher === 'jackbox games inc.') {
    imgSrc = 'jackbox.png';
    cssClass = 'jackbox-logo';
    title = 'Jackbox Games Inc.';
  }

  if (trimmedPublisher === 'paradox interactive') {
    imgSrc = 'paradox.png';
    cssClass = 'paradox-logo';
    title = 'Paradox Interactive';
  }

  if (trimmedPublisher === 'rockstar games') {
    imgSrc = 'rockstar.png';
    cssClass = 'rockstar-logo';
    title = 'Rockstar Games';
  }

  if (trimmedPublisher === 'plug in digital') {
    imgSrc = 'plug-in-digital.png';
    cssClass = 'plug-in-logo';
    title = 'Plug In Digital';
  }

  if (trimmedPublisher === 'disney interactive') {
    imgSrc = 'disney-black.png';
    cssClass = 'disney-logo';
    title = 'Disney Interactive';
  }

  if (trimmedPublisher === 'deep silver') {
    imgSrc = 'deep-silver.png';
    cssClass = 'deepsilver-logo';
    title = 'Deep Silver';
  }

  if (trimmedPublisher === 'stardock entertainment') {
    imgSrc = 'stardock-logo2.png';
    cssClass = 'stardock-logo';
    title = 'Stardock Entertainment';
  }

  if (trimmedPublisher === 'devolver digital') {
    imgSrc = 'devolver-digital-logo.png';
    cssClass = 'devolver-logo';
    title = 'Devolver Digital';
  }

  if (trimmedPublisher === '505 games') {
    imgSrc = '505-games-logo.svg';
    cssClass = 'five-o-five-logo';
    title = '505 Games';
  }

  if (trimmedPublisher === 'team17 digital ltd') {
    imgSrc = 'team-17-logo.png';
    cssClass = 'team-seventeen-logo';
    title = 'Team17 Digital';
  }

  if (trimmedPublisher === 'square enix') {
    imgSrc = 'squareenix-logo.svg';
    cssClass = 'squareenix-logo';
    title = 'Square Enix';
  }

  if (trimmedPublisher === 'focus home interactive') {
    imgSrc = 'focus-home-interactive-2021.png';
    cssClass = 'focus-home-logo';
    title = 'Focus Home Interactive';
  }

  if (trimmedPublisher === 'focus entertainment') {
    imgSrc = 'focus-home-interactive-2022.svg';
    cssClass = 'focus-home-entertainment-logo';
    title = 'Focus Entertainment';
  }

  if (trimmedPublisher === 'playstation pc llc games') {
    imgSrc = 'playstation.svg';
    cssClass = 'playstation-logo';
    title = 'Playstation PC LLC Games';
  }

  if (trimmedPublisher === 'xbox game studios') {
    imgSrc = 'xbox.svg';
    cssClass = 'xbox-logo';
    title = 'Xbox Game Studios';
  }

  // FantasyVerse Publishers

  if (trimmedPublisher === 'american mythology') {
    imgSrc = 'american-mythology.png';
    cssClass = 'american-mythology-logo';
    title = 'American Mythology';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'z2 comics') {
    imgSrc = 'z2-comics.svg';
    cssClass = 'ztwo-comics-logo';
    title = 'Z2 Comics';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'taylor and francis') {
    imgSrc = 'taylor-and-francis.png';
    cssClass = 'taylor-francis-logo';
    title = 'Taylor & Francis';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'karl drinkwater') {
    imgSrc = 'karl-drinkwater.png';
    cssClass = 'karl-drinkwater-logo';
    title = 'Karl Drinkwater';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'nbm publishing') {
    imgSrc = 'nbm-publishing.png';
    cssClass = 'nbm-logo';
    title = 'NBM Publishing';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'dark horse comics') {
    imgSrc = 'dark-horse.png';
    cssClass = 'dark-horse-logo';
    title = 'Dark Horse Comics';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'an inkwell of nectar') {
    imgSrc = 'an-inkwell-of-nectar.png';
    cssClass = 'an-inkwell-of-nectar-logo';
    title = 'An Inkwell of Nectar';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'medibang inc') {
    imgSrc = 'medibang.svg';
    cssClass = 'medibang-logo';
    title = 'Medibang';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'boss fight books') {
    imgSrc = 'boss-fight-books.png';
    cssClass = 'boss-fight-books-logo';
    title = 'Boss Fight Books';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'austin dragon') {
    imgSrc = 'austin-dragon.png';
    cssClass = 'austin-dragon-logo';
    title = 'Austin Dragon';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'michael la ronn') {
    imgSrc = 'michael-la-ronn-black.png';
    cssClass = 'michael-la-ronn-logo';
    title = 'Michael La Ronn';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'katie cross') {
    imgSrc = 'katie-cross-logo.png';
    cssClass = 'katie-cross-logo';
    title = 'Katie Cross';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'dark wave') {
    imgSrc = 'dark-wave-logo.png';
    cssClass = 'dark-wave-logo';
    title = 'Dark Wave';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'T PUB LTD') {
    imgSrc = 'twisted-comics-logo.png';
    cssClass = 'twisted-comics-logo';
    title = 'T PUB LTD';
    fantasyVerse = true;
  }

  if (trimmedPublisher === 'cg harris') {
    imgSrc = 'cg-harris.png';
    cssClass = 'cg-harris-logo';
    title = 'C.G. Harris';
    fantasyVerse = true;
  }

  const url = `/publishers/${encodeSlug(trimmedPublisher)}`;

  const trackClick = () => {
    store.dispatch({
      type: 'frontend/click/CLICK_INTERACTION',
      payload: { section: fantasyVerse ? 'FantasyVersePublishers' : 'HomePublishers', value: url, context: `Publisher${index}` },
    });
  };

  if (!imgSrc) {
    return false;
  }

  if (publisherCarousel) {
    return (
      <div className="slide-container">
        <Link to={url} title={title} className="publisher-box-container" onClick={() => { trackClick(); }}>
          <div className={classNames('publisher-box', { 'with-discount-bar': showDiscountBar })}>
            {fantasyVerse &&
              <img
                src={`https://fanatical.imgix.net/brand/about-us/publishers/${imgSrc}?${imgixConfig}`}
                alt={title || publisher}
                className={cssClass}
              />
            }

            {!fantasyVerse &&
              <FluidImg
                src={imgSrc}
                folder="brand/about-us/publishers"
                alt={title}
                className={cssClass}
              />
            }
          </div>
          {showDiscountBar &&
            <div className="deal-number-bar">
              <FormattedMessage
                id="publisherBox.deals"
                defaultMessage="{discounts, plural, one {# Deal} other {# Deals}}"
                values={{ discounts }}
              />
            </div>
          }
        </Link>
      </div>
    );
  }

  return (
    <Link
      to={url}
      title={title}
      className={
        classNames(
          'publisher-box-container',
          { 'mr-0': index % 4 === 0 },
        )
      }
      onClick={() => { clickFunction(); trackClick(); }}
    >
      <div className={classNames('publisher-img', { 'with-discount-bar': showDiscountBar })}>
        <FluidImg
          src={imgSrc}
          folder="brand/about-us/publishers"
          alt={title || publisher}
          className={cssClass}
        />
      </div>
      {showDiscountBar &&
        <div className="deal-number-bar">
          <FormattedMessage
            id="publisherBox.deals"
            defaultMessage="{discounts, plural, one {# Deal} other {# Deals}}"
            values={{ discounts }}
          />
        </div>
      }
    </Link>
  );
}

PublisherBox.propTypes = {
  publisher: PropTypes.string,
  discounts: PropTypes.number,
  index: PropTypes.number,
  publisherCarousel: PropTypes.bool,
  showDealNumbers: PropTypes.bool,
  clickFunction: PropTypes.func,
};

PublisherBox.defaultProps = {
  publisher: '',
  discounts: 0,
  index: 0,
  publisherCarousel: false,
  showDealNumbers: false,
  clickFunction: () => {},
};
